import Joi from "joi-browser";

const CreateAndEditMaterialGroupSchema = Joi.object().keys({
    name: Joi.string()
        .trim()
        .required()
        .label("Name")
        .error((errors) => {
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: "is required",
                },
            };
        }),
});

export default { CreateAndEditMaterialGroupSchema };
